module.exports = __webpack_public_path__ + "travel_trash.svg";